import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'
import FontIcon from 'react-toolbox/lib/font_icon'

import styles from './styles.scss'

const CollapseIcon = (props) => {
  const { collapse } = props
  const value = collapse ? 'expand_more' : 'expand_less'
  return (
    <FontIcon value={value}/>
  )
}

CollapseIcon.propTypes = {
  collapse: PropTypes.bool.isRequired,
}

CollapseIcon.defaultProps = {
  collapse: false
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(CollapseIcon)
